<template>  
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
    <v-flex xs6 class="inline-block px-4">
      <v-text-field hide-details :label="$t('Admin.UmbClasse.Form.Key')" v-model="umc_key" />
      <v-text-field hide-details :label="$t('Admin.UmbClasse.Form.Surname')" v-model="umc_libelle" />            
    </v-flex>                         
  </v-layout>      
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminUmbClasseForm'
})
export default class AdminUmbClasseForm extends Vue {  

  get modified(){
    return this.$store.myGetters.modifiedAdmUmbClasse
  }
      
  get umc_key() {
    return this.modified.UMC_KEY!
  }
  set umc_key(value:string) {
    this.$store.myActions.UMBCLASSE_UPDATE_MODIFIED_ADM({
      UMC_KEY:value
    })
  }

  get umc_libelle(){
    return this.modified.UMC_LIBELLE!
  }
  set umc_libelle(value:string){    
    this.$store.myActions.UMBCLASSE_UPDATE_MODIFIED_ADM({
      UMC_LIBELLE:value
    })
  }

}
</script>